import { useState } from "react";
import Row from "antd/es/row";
import Col from "antd/es/col";
import Drawer from "antd/es/drawer";
import { withTranslation, TFunction } from "react-i18next";
import { Link } from "react-router-dom";
import Container from "../../common/Container";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  LogoTitle,
} from "./styles";

const Header = ({ t, i18n }: { t: TFunction; i18n: any }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const switchLanguage = () => {
    const currentLang = i18n.language;
    i18n.changeLanguage(currentLang === "en" ? "cn" : "en");
  };

  // Get the brand name based on current language
  const getBrandName = () => {
    return i18n.language === "cn" ? "CapCam 3D相机" : "CapCam";
  };

  const MenuItem = () => {
    return (
      <>
        <CustomNavLinkSmall onClick={switchLanguage}>
          <img
            src="/img/svg/language.svg"
            alt="Switch Language"
            width="24"
            height="24"
            style={{ cursor: "pointer" }}
          />
        </CustomNavLinkSmall>
      </>
    );
  };

  const HomeMenuItem = () => {
    return (
      <CustomNavLinkSmall 
        as={Link} 
        to="/"
        style={{ 
          color: "#1d1d1f", 
          fontWeight: "500",
          padding: "8px 16px",
          textDecoration: "none"
        }}
      >
        {t("Home")}
      </CustomNavLinkSmall>
    );
  };

  const StoriesMenuItem = () => {
    return (
      <CustomNavLinkSmall 
        as={Link} 
        to="/stories"
        style={{ 
          color: "#1d1d1f", 
          fontWeight: "400",
          padding: "8px 16px",
          textDecoration: "none"
        }}
      >
        {t("Stories")}
      </CustomNavLinkSmall>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between" align="middle">
          <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
            <LogoContainer to="/" aria-label="homepage">
              <img
                src="/favicon.svg"
                alt="CapCam Logo"
                width="36"
                height="36"
                style={{ marginRight: "10px" }}
              />
              <LogoTitle>{getBrandName()}</LogoTitle>
            </LogoContainer>
            <NotHidden>
              <HomeMenuItem />
              <StoriesMenuItem />
            </NotHidden>
          </div>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <HomeMenuItem />
          <StoriesMenuItem />
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
